<app-spinner></app-spinner>
<div class="d-block" style="overflow: auto">
  <router-outlet></router-outlet>
</div>
